var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24 42c9.941 0 18-8.059 18-18S33.941 6 24 6 6 14.059 6 24s8.059 18 18 18zm.251-26.346c-1.361 0-2.042.611-2.042 1.833 0 1.23.68 1.846 2.042 1.846.681 0 1.19-.16 1.526-.48.345-.328.517-.783.517-1.366 0-1.222-.68-1.833-2.043-1.833zM22.37 33h3.753V21.043H22.37V33z",
    clipRule: "evenodd"
  })));
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 48 48'%3e%3cpath fill='%23003594' fill-rule='evenodd' d='M24 42c9.941 0 18-8.059 18-18S33.941 6 24 6 6 14.059 6 24s8.059 18 18 18zm.251-26.346c-1.361 0-2.042.611-2.042 1.833 0 1.23.68 1.846 2.042 1.846.681 0 1.19-.16 1.526-.48.345-.328.517-.783.517-1.366 0-1.222-.68-1.833-2.043-1.833zM22.37 33h3.753V21.043h-3.753V33z' clip-rule='evenodd'/%3e%3c/svg%3e";
export { SvgInfoFilled as ReactComponent };